import DatePicker from "react-datepicker";
import { format } from "date-fns";
import React, { useRef, useState, useEffect } from 'react';
import { MODALS } from '../utils/constants';

const CANVAS_WIDTH = 1080;
const CANVAS_HEIGHT = 1350;
const BOTTOM_MARGIN = 125;
const LEFT_MARGIN = 70;
const SUBTITLE_FONT_SIZE = 33;
const DEFAULT_FONT_STYLE = `bold ${SUBTITLE_FONT_SIZE}px 'Univers-Condensed'`;
const DEFAULT_TITLE_SIZE = 56;
const SMALL_TITLE_SIZE = 43;
const SUBTITLE_MARGIN = 16;
const INPUT_FIELD_MARGIN = 12;
const TITLE_PLACEHOLDER = "TITLE / ARTIST NAME";

let LOGO_WHITE, LOGO_BLACK, BACKGROUND_IMAGE;
if (typeof Image != "undefined") {
     LOGO_WHITE = new Image();
     LOGO_WHITE.src = "./img/logo_white.svg";
     LOGO_BLACK = new Image();
     LOGO_BLACK.src = "./img/logo_black.svg";
}

 const FIELDS = {
    title: 'title',
    subtitle: 'subtitle',
    location: 'location',
    broadcastDate: 'broadcastDate',
    broadcastStartTime: 'broadcastStartTime',
    titleSize: 'titleSize',
    colourTheme: 'colourTheme',
};

const THEMES = {
    light: 'light',
    dark: 'dark',
    lightPlus: 'lightPlus',
};

const START_TIMES = [
    '00:00', '01:00', '03:00', '04:00', '05:00', '06:00', '07:00',
    '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00',
    '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00',
];

function titleBottomMargin(hasSubtitle) {
    if (hasSubtitle) return CANVAS_HEIGHT - (BOTTOM_MARGIN + SUBTITLE_FONT_SIZE + SUBTITLE_MARGIN);

    return CANVAS_HEIGHT - BOTTOM_MARGIN;
}

function caluculateImageSize(width, height) {
    if (width/height > CANVAS_WIDTH/CANVAS_HEIGHT) { //image more landscape
        const dWidth = (width / height) * CANVAS_HEIGHT;
        const dx = (CANVAS_WIDTH - dWidth)/2; //horizontally center the image
        return { dx, dy: 0, dWidth, dHeight: CANVAS_HEIGHT };
    }

    const dHeight = (height / width) * CANVAS_WIDTH;
    const dy = (CANVAS_HEIGHT - dHeight)/2; //vertcally center the image
    return { dx: 0, dy, dWidth: CANVAS_WIDTH, dHeight };
}

function SocialFlyer({ setModalOpen, imageFile }) {
    const canvasRef = useRef(null);
    if (!BACKGROUND_IMAGE) {
        BACKGROUND_IMAGE = new Image();
        BACKGROUND_IMAGE.crossOrigin = "anonymous";
        BACKGROUND_IMAGE.addEventListener("load", () => {
            setImageWidth(BACKGROUND_IMAGE.width);
            setImageHeigth(BACKGROUND_IMAGE.height);
            setImageCacheKey(Date.now());
        });
    }

    const [ctx, setCtx] = useState(null);
    const [title, setTitle] = useState("");
    const [subtitle, setSubtitle] = useState("");
    const [location, setLocation] = useState("");
    const [broadcastDate, setBroadcastDate] = useState(new Date());
    const [broadcastStartTime, setBroadcastStartTime] = useState(START_TIMES[0]);
    const [titleSize, setTitleSize] = useState(DEFAULT_TITLE_SIZE);
    const [colourTheme, setcolourTheme] = useState(THEMES.light);
    const [imageCacheKey, setImageCacheKey] = useState(null);
    const [imageWidth, setImageWidth] = useState(CANVAS_WIDTH);
    const [imageHeight, setImageHeigth] = useState(CANVAS_HEIGHT);

    function handleChange(e) {
        const { name, value } = e.target;
        switch(name) {
            case FIELDS.title:
                setTitle(value.toUpperCase());
                break;
            case FIELDS.subtitle:
                setSubtitle(value.toUpperCase());
                break;
            case FIELDS.location:
                setLocation(value.toUpperCase());
                break;
            case FIELDS.broadcastDate:
                setBroadcastDate(value.toUpperCase());
                break;
            case FIELDS.broadcastStartTime:
                setBroadcastStartTime(value);
                break;
            case FIELDS.titleSize:
                setTitleSize(value === 'small' ? SMALL_TITLE_SIZE : DEFAULT_TITLE_SIZE);
                break;
            case FIELDS.colourTheme:
                setcolourTheme(value);
                break;
        }
    }

    function draw() {
        if (!ctx) return;

        if (BACKGROUND_IMAGE.src) {
            const { dx, dy, dWidth, dHeight } = caluculateImageSize(imageWidth, imageHeight);
            ctx.drawImage(BACKGROUND_IMAGE, dx, dy, dWidth, dHeight);
        } else {
            ctx.fillStyle = `rgba(170, 170, 170)`;
            ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
        }

        if (colourTheme === THEMES.lightPlus) {
            ctx.globalAlpha = 0.2;
            ctx.fillStyle = "black";
            ctx.fillRect(0, 0,  CANVAS_WIDTH, CANVAS_HEIGHT);
            ctx.globalAlpha = 1.0;
            ctx.fillStyle = "white";
        }

        ctx.letterSpacing = "1px";
        ctx.font = DEFAULT_FONT_STYLE;
        ctx.fillStyle = colourTheme === THEMES.dark ? "black" : "white";
        ctx.textAlign = "right";

        ctx.save();
        ctx.translate(0, 0);
        ctx.rotate( Math.PI / 2 );
        ctx.fillText("NTS.LIVE", CANVAS_HEIGHT - BOTTOM_MARGIN, -(CANVAS_WIDTH - LEFT_MARGIN - 24));
        ctx.restore();

        ctx.fillText(
            [format(broadcastDate, "ccc d MMM").toUpperCase(), broadcastStartTime].join(' | '),
            CANVAS_WIDTH - LEFT_MARGIN,
            (BOTTOM_MARGIN + 24)
        );
        ctx.fillText(
            location,
            CANVAS_WIDTH - LEFT_MARGIN,
            (BOTTOM_MARGIN + DEFAULT_TITLE_SIZE + SUBTITLE_MARGIN)
        );

        ctx.drawImage(
            colourTheme === "dark" ? LOGO_BLACK : LOGO_WHITE,
            LEFT_MARGIN, BOTTOM_MARGIN, 76, 76
        );

        ctx.textAlign = "left";
        ctx.font = `bold ${titleSize}px 'Univers-Condensed`;
        ctx.fillText(
            title || TITLE_PLACEHOLDER,
            LEFT_MARGIN,
            titleBottomMargin(!!subtitle)
        );

        if (subtitle) {
            ctx.font = DEFAULT_FONT_STYLE;
            ctx.fillText(subtitle, LEFT_MARGIN, CANVAS_HEIGHT - BOTTOM_MARGIN);
        }
    }

    function loadImage() {
        if (!imageFile) return;

        const reader = new FileReader();
        reader.readAsDataURL(imageFile);
        reader.addEventListener( "load", () => {
            BACKGROUND_IMAGE.src = reader.result;
        });
    }

    function downloadImage(e) {
        e.preventDefault();
        const imgUrl = canvasRef.current.toDataURL("image/png");
        const createEl = document.createElement("a");
        createEl.href = imgUrl;
        createEl.download = [title, format(broadcastDate, "d-MMM"), Date.now()].join('-');
        createEl.click();
        createEl.remove();
    }

    useEffect(() => {
        const canvas = canvasRef.current;
        canvas.height = CANVAS_HEIGHT;
        canvas.width = CANVAS_WIDTH;
        setCtx(canvas.getContext('2d'));
    }, []);

    useEffect(() => {
        draw();
    }, [ctx, title, subtitle, location, broadcastDate, broadcastStartTime, titleSize, colourTheme, imageCacheKey]);

    useEffect(() => {
        loadImage();
    }, [imageFile]);

    return (
        <div className="mdl-grid">
            <div className="card mdl-cell mdl-cell--6-col">
                <h2 className="card__title">Social Flyer Info</h2>
                <label className="mdl-typography--body-1 text-bold" htmlFor={FIELDS.title}>
                    Title
                </label>
                <input
                    id={FIELDS.title}
                    name={FIELDS.title}
                    className="mdl-textfield__input"
                    style={{ marginBottom: INPUT_FIELD_MARGIN }}
                    placeholder={TITLE_PLACEHOLDER}
                    onChange={handleChange}
                    value={title} />
                <label className="mdl-typography--body-1 text-bold" htmlFor={FIELDS.subtitle}>
                    Subtitle
                </label>
                <input
                    id={FIELDS.subtitle}
                    name={FIELDS.subtitle}
                    className="mdl-textfield__input mdl-typography--body-1"
                    style={{ marginBottom: INPUT_FIELD_MARGIN }}
                    placeholder="SUBTITLE / GUEST NAME"
                    onChange={handleChange}
                    value={subtitle} />
                <label className="mdl-typography--body-1 text-bold" htmlFor={FIELDS.location}>
                    Location
                </label>
                <input
                    id={FIELDS.location}
                    name={FIELDS.location}
                    className="mdl-textfield__input mdl-typography--body-1"
                    style={{ marginBottom: INPUT_FIELD_MARGIN }}
                    placeholder="CITY or REGION"
                    onChange={handleChange}
                    value={location} />
                <label className="mdl-typography--body-1 text-bold" htmlFor={FIELDS.broadcastDate}>
                    Broadcast Date (YYYY/MM/DD)
                </label>
                <div style={{ marginBottom: '12px' }}>
                    <DatePicker className="mdl-textfield__input" selected={broadcastDate} dateFormat="yyyy/MM/dd" onChange={(date) => setBroadcastDate(date)} />
                </div>
                <div>
                    <label className="mdl-typography--body-1 text-bold" htmlFor={FIELDS.broadcastStartTime}>
                        Broadcast Start Time
                    </label>
                </div>
                <div style={{ paddingTop: '0px', paddingBottom: '12px', width: '46%' }} className="mdl-textfield">
                    <select className="mdl-textfield__input" name={FIELDS.broadcastStartTime} id={FIELDS.broadcastStartTime} onChange={handleChange}>
                        { START_TIMES.map((ts, i) => <option value={ts} key={i}>{ts}</option>) }
                    </select>
                </div>
                <div>
                    Please ensure you select the date and time as in the stated location. For example, if you state Berlin, select the date and time the broadcast will air in Berlin.
                </div>
            </div>
            <div className="mdl-cell mdl-cell--6-col">
                <canvas style={{ maxWidth: "100%" }} ref={canvasRef} />
            </div>
            <div className="card mdl-cell mdl-cell--6-col">
                <h2 className="card__title">Font Size & Colour</h2>
                <div>
                    <label className="mdl-typography--body-1 text-bold" htmlFor={FIELDS.titleSize}>
                        Title Size
                    </label>
                </div>
                <div style={{ paddingTop: '0px', paddingBottom: '12px', width: '46%' }} className="mdl-textfield">
                    <select className="mdl-textfield__input" name={FIELDS.titleSize} id={FIELDS.titleSize} onChange={handleChange}>
                        <option value="large">Large</option>
                        <option value="small">Small</option>
                    </select>
                </div>
                <div>
                    <label className="mdl-typography--body-1 text-bold" htmlFor={FIELDS.colourTheme}>
                        Colour
                    </label>
                </div>
                <div style={{ paddingTop: '0px', paddingBottom: '12px', width: '46%' }} className="mdl-textfield">
                    <select className="mdl-textfield__input" name={FIELDS.colourTheme} id={FIELDS.colourTheme} onChange={handleChange}>
                        <option value={THEMES.light}>Light</option>
                        <option value={THEMES.dark}>Dark</option>
                        <option value={THEMES.lightPlus}>Light+</option>
                    </select>
                </div>
            </div>
            <div className=" mdl-cell mdl-cell--6-col">
                    <button
                        className="mdl-button mdl-button--raised button-blue"
                        onClick={() => setModalOpen(MODALS.socialFlyerImage)}
                        style={{ minWidth: '150px', float: "right", marginBottom: '24px' }}
                        >
                        Upload image
                    </button>
                    <br />
                    <button
                        className="mdl-button mdl-button--raised button-blue"
                        onClick={downloadImage}
                        style={{ width: '100%', marginBottom: '24px' }}
                        disabled={!imageCacheKey}>
                        Download
                    </button>
            </div>
        </div>
    );
}

export default SocialFlyer;
